import React, {Fragment, useContext} from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import {Route, Switch, useLocation} from "react-router-dom";

import { getContactRouterLink, getContactRouterPath} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import ContactMessagingSubmenu from "root/Wieldy/ApplicationModules/Contact/Sidebar/ContactMessagingSubmenu";

const ContactAppSidebar = (props) =>
{
    const { pathname }  = useLocation();

    // Note this will change if you add any more items to the AppSidebarGroup below
    const default_menu = pathname.includes('/messages') ? 'messages' : 'messages' ;

    const contactSubmenu =() =>{
        return(
            <Fragment>
                <AppSidebarGroup title='View' default={default_menu}>
                    <AppSidebarMenuItem link={getContactRouterLink(props.user_id, 'messages')} title='Messages' iconName='icon-user-o' name='messages' />
                </AppSidebarGroup>
            </Fragment>
        )
    }

    return (
        <div className="dt-module__sidebar">

            <div className="dt-module__sidebar-header border-bottom">
                <div className="d-none d-md-flex align-items-center justify-content-center">
                    <i className={ "icon " + props.iconName + " icon-2x mr-4"}/>
                    <span className="h2 mb-0 text-muted">{props.title}</span>
                </div>
            </div>

            { /* Sidebar Menu */}
            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    {contactSubmenu()}

                    <Switch>
                        <Route path={getContactRouterPath('messages')} render={(thisprops) => <ContactMessagingSubmenu user_id={props.user_id} {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default ContactAppSidebar;
